import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const relatedLinks = [{
  title: 'Taekwondo Near Me',
  href: '/taekwondo-near-me-in-farmington-hills-michigan'
}, {
  title: 'Farmington Hills',
  href: '/farmington-hills-martial-arts-program-storm-taekwondo'
}, {
  title: 'Novi',
  href: '/novi-martial-arts-program-storm-taekwondo'
}, {
  title: 'Commerce',
  href: '/commerce-martial-arts-program-storm-taekwondo'
}, {
  title: 'Livonia',
  href: '/livonia-martial-arts-program-storm-taekwondo'
}, {
  title: 'Farmington',
  href: '/farmington-martial-arts-program-storm-taekwondo'
}, {
  title: 'Waterford',
  href: '/waterford-martial-arts-program-storm-taekwondo'
}, {
  title: 'Northville',
  href: '/northville-martial-arts-program-storm-taekwondo'
}, {
  title: 'Programs Overview',
  href: '/Programs.html'
}];
export function MartialArtsNearMeRelatedLinks() {
  return <section className="py-20 bg-off-white border-t border-subtle-gray" data-id="element-2474">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2475">
        <h2 className="text-3xl md:text-4xl text-ink text-center mb-12" data-id="element-2476">
          Related Classes & Programs
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2477">
          {relatedLinks.map(link => <Link key={link.href} to={link.href} className="group bg-paper border border-subtle-gray hover:border-storm-red rounded-2xl p-6 transition-all flex items-start justify-between gap-4" data-id="element-2478">
              <div data-id="element-2479">
                <p className="font-bold text-ink text-lg mb-1" data-id="element-2480">{link.title}</p>
              </div>
              <ArrowRight className="w-5 h-5 text-storm-red shrink-0 mt-1 group-hover:translate-x-1 transition-transform" data-id="element-2481" />
            </Link>)}
        </div>
      </div>
    </section>;
}